"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _chunk7Y3FNKTFcjs = require('./chunk-7Y3FNKTF.cjs');


var _chunkLRJOJOOScjs = require('./chunk-LRJOJOOS.cjs');


var _chunkI4SOZEKKcjs = require('./chunk-I4SOZEKK.cjs');

// src/contracts/pTON/index.ts
var pTON = {
  [_chunkI4SOZEKKcjs.pTON_VERSION.v1]: _chunkLRJOJOOScjs.PtonV1,
  [_chunkI4SOZEKKcjs.pTON_VERSION.v2_1]: _chunk7Y3FNKTFcjs.PtonV2_1
};



exports.pTON = pTON;
//# sourceMappingURL=chunk-SAHPOPRF.cjs.map